// removed by extract-text-webpack-plugin
module.exports = {"betButtons":"_3Fmsg7Z7_PaMHA_HWPElbf","buttonsColumn":"_2oK-hz6Gg-lyVvJOKNRTdO","oddsText":"_2nHykV7Jee0LNCvGOIApeu","racerIconImage":"_1-XWvL6u7otahp2-DvFy6k","button":"_1AK3vwMdBnTyHYr_XHHPrj","selected":"_21r8RJiQBqPZRqCcVYtU2H","betChipsContainer":"_3-LejzFawuQbXzN8V73WbA","betChips":"_2OfOZ_mfEtIuQvtMfESg1p","chipValueOuter":"_8L5DnD0rhg-55VNlDxSBN","chipValueInner":"_3F6TMlcZd2U_3HjJeC6L5z"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/complexBetButtons.css
// module id = 1011
// module chunks = 0